import React from "react";
import { useNavigate } from "react-router-dom";
import linkedin from "../../assets/images/profile/linkedin.svg";
import github from "../../assets/images/profile/github.svg";
import twitter from "../../assets/images/profile/twitter.svg";
import star from "../../assets/images/profile/star.svg";
import { StarIcon } from "@heroicons/react/solid";

const ProfileSection = ({ profileData, pageType, role }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex flex-col py-6 px-10 justify-evenly h-[calc(100vh-4rem)] xl:w-80 w-72 rounded-2xl border-[#B2B7FF] border-2">
        <div className="flex flex-col items-center">
          <img
            className="inline object-cover w-24 h-24 rounded-full"
            src={profileData.profilePictureLink}
            alt="Profile"
          />
        </div>
        <div className="font-semibold text-center">
          <h1 className="mb-2">{profileData.bio}</h1>
          <h1 className="font-normal text-[#777777]">{profileData.name}</h1>
          <h1 className="font-normal text-[#777777]">
            {profileData.department}&nbsp;Department
          </h1>
          <h1 className="font-normal text-[#777777]">
            {profileData.collegeEmailId}
          </h1>
          <h1 className="font-normal text-[#777777]">
            {profileData.personalEmailId}
          </h1>
        </div>
        <div className="flex flex-col justify-center mt-3">
          <button
            type="button"
            onClick={() =>
              navigate(
                pageType === "profile"
                  ? role === "teacher"
                    ? "/teacher/starred-projects"
                    : "/student/starred-projects"
                  : role === "teacher"
                  ? "/teacher/guided-projects"
                  : "/student/completed-projects"
              )
            }
            className="bg-[#C5C8FF] hover:bg-[#8389ff] text-white font-bold rounded-full flex flex-row py-2 justify-center"
          >
            {pageType === "profile" && (
              <img
                src={star}
                alt="star"
                className="w-6 h-6 mx-1 align-middle"
              />
            )}
            <h1 className="mx-3">
              {pageType === "profile"
                ? "Starred "
                : role === "teacher"
                ? "Guided "
                : "Completed "}
              Projects
            </h1>
          </button>
        </div>

        <div className="flex flex-col items-center mt-3">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <div className="flex flex-col items-center">
          <div>
            <a
              href={profileData.linkedIn}
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="flex flex-col items-center my-4 hover:cursor-pointer">
                <img
                  className="inline object-cover w-6 h-6"
                  src={linkedin}
                  alt="LinkedIn"
                />
                <h1>LinkedIn</h1>
              </div>
            </a>
            <a
              href={profileData.gitHub}
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="flex flex-col items-center my-4 hover:cursor-pointer">
                <img
                  className="inline object-cover w-6 h-6"
                  src={github}
                  alt="GitHub"
                />
                <h1>GitHub</h1>
              </div>
            </a>
            <a
              href={profileData.twitter}
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="flex flex-col items-center my-4 hover:cursor-pointer">
                <img
                  className="inline object-cover w-6 h-6"
                  src={twitter}
                  alt="Twitter"
                />
                <h1>Twitter</h1>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileSection;
